// Centralized WhatsApp helpers and message templates

// WhatsApp requires full international number without + sign (country code + number)
export const WHATSAPP_PHONE = '919001971755'; // 91 (India) + 9001971755

export const openWhatsApp = (message) => {
  const encoded = encodeURIComponent(message);
  const url = `https://wa.me/${WHATSAPP_PHONE}?text=${encoded}`;
  window.open(url, '_blank');
};

export const openDialer = (phone = WHATSAPP_PHONE) => {
  // For tel: links, we need +country code format
  // If phone already includes country code, use as is, otherwise add +91
  const formattedPhone = phone.startsWith('91') ? `+${phone}` : `+91${phone}`;
  
  // Create a temporary anchor element and click it to avoid browser popup issues
  const link = document.createElement('a');
  link.href = `tel:${formattedPhone}`;
  link.style.display = 'none';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

const formatKeyVal = (label, value) => (value ? `- ${label}: ${value}` : undefined);

export const buildWelcomeHeader = () => {
  return 'Welcome to Wonder Eventz 🎉\n';
};

export const buildPackageMessage = (pkg) => {
  const header = buildWelcomeHeader();
  const lines = [
    'Package Inquiry',
    formatKeyVal('Title', pkg && pkg.title),
  ].filter(Boolean);
  return `${header}\n${lines.join('\n')}`;
};

export const buildContactMessage = (formData) => {
  const header = buildWelcomeHeader();
  const lines = [
    'New Contact Form Submission',
    formatKeyVal('Full Name', formData.name),
    formatKeyVal('Email', formData.email),
    formatKeyVal('Phone', formData.phone),
    formatKeyVal('Event Type', formData.eventType),
    '',
    'Message:',
    formData.message,
  ].filter(Boolean);
  return `${header}\n${lines.join('\n')}`;
};


